<template>
<div class="chapter">
<div class="inner_page">
<p class="p11"><span class="sz"><b>Dedication</b></span></p>
<div style="text-align:center"><img alt="flourish" src="images/flourish.png"/></div>
<p class="p12"><span class="sz">Dedicated to my dearest friend,</span></p>
<p class="p3"><span class="sz"><b>Marliss E. Melton</b></span></p>
<p class="p3"><span class="sz">You've been with me every step of the way.</span></p>
<p class="p3"><span class="sz">And I honestly don't think I could have, or would have,</span></p>
<p class="p3"><span class="sz">published my first book without your support.</span></p>
<p class="p3"><span class="sz"><i>Love you.</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section4.vue?f534c8b0